export const PLACEMAT_STRINGS = {
  title: "Let's make your move as smooth as possible",
  improvementsTitle: 'View Move-Out Report',
};
